import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';

export * from '../../thunk/customerFormSubmissions';

const CustomerFormSubmissionsSlice = createSlice({
    name: 'customerFormSubmissions',
    initialState: {
        list: [] as any[],
        singleSubmission: null as any,
        types: [] as any[],
        status: null as string | null,
        singleStatus: null as string | null,
        typesStatus: null as string | null,
        error: null as string | null,
        singleError: null as string | null,
        queryParams: {
            page: 1,
            limit: 50,
            sortDirection: 'DESC',
            typeId: null,
            email: null,
            processed: null,
            createdAtMin: null,
            createdAtMax: null,
            total: 0,
        } as any,
    },
    reducers,
    extraReducers,
});

const { actions, reducer } = CustomerFormSubmissionsSlice;
export const { clearCustomerFormSubmissionsFilters, setCustomerFormSubmissionsList } = actions;
export { reducer };
